import { lkInfo } from '../../api'

export const InfoStoreService = () => {
  return lkInfo()
}
